import React from 'react';
import PropTypes from 'prop-types';
import OptionalProduct from './OptionalProduct';
import Card from './Card';
import CalculateProductSize from './CalculateProductSize';

class OptionalProductContainer extends React.Component {
  state = {
    sku: undefined,
    duration: undefined,
    activeContents: undefined,
    activeProducts: [],
  };


  componentWillReceiveProps(nextProps) {


  }

  handleProductClick = click => () => {
    this.setState({ sku: click.sku, duration: click.duration }, () => {
      this.props.onClickProduct(click);
    });
  };

  checkIfProductIsComplete = () => {
    const { sku, duration } = this.state;

    if (sku !== undefined &&
    duration !== undefined) {
      this.props.onClickProduct({ sku, duration });
    }
  };


  render() {
    const {
      items,
      settings,
      onClickProduct,
      activeOptionalProducts,
      activeProductCost,
      activeParticipant,

    } = this.props;
    const {
      activeProducts,
      activeContents,
      sku: stateSku,
      duration: stateDuration,
    } = this.state;

    const { sumProduct } = settings;

    const showExtras = false;


    return (
      <React.Fragment>
        <Card title="Tillval">
          <CalculateProductSize
          nrOfProducts={5}
          >


            {items.map(({
 index, sku, perPerson, percent, name, cost, ...rest
}) => {
       const clicked = activeOptionalProducts.filter(active => active.sku === sku).length > 0;
       let productCost = cost;
       if (percent) {
         if (sumProduct && activeParticipant !== undefined && activeProductCost !== undefined) {
           productCost = ((activeProductCost * activeParticipant) / 100) * cost;
         } else {
           productCost = ((activeProductCost) / 100) * cost;
         }
       }


              return (
                <OptionalProduct
                  key={sku}
                  sku={sku}
                  name={name}
                  cost={productCost}
                  perPerson={perPerson}
                  percent={percent}
                  clicked={clicked}
                  onClick={this.handleProductClick({
 sku, perPerson, percent, name, cost,
})}
                  {...rest}
                />
          );
})}

          </CalculateProductSize>
        </Card>
      </React.Fragment>
    );
  }
}

OptionalProductContainer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onClickProduct: PropTypes.func.isRequired,
  activeParticipant: PropTypes.number,
  activeProduct: PropTypes.number,
};

export default OptionalProductContainer;



// WEBPACK FOOTER //
// ./src/components/Resource/components/OptionalProductContainer.jsx